import React, { JSX, SVGProps } from 'react'

// Grid's green unless a branded console sets --brand-mark from its primary colour.
export const BRAND_MARK_COLOR = 'var(--brand-mark, #14362F)'
// The light-mode brand colour in either theme, for previews of things that are always white, like an email.
export const BRAND_MARK_LIGHT_COLOR = 'var(--brand-mark-light, #14362F)'

type SvgComponent = (props: SVGProps<SVGSVGElement>) => React.ReactElement;

export default function createIcon(SvgElement: JSX.Element): SvgComponent {
  return function Icon(props) {
    return React.cloneElement(SvgElement, props)
  }
}
